export default __webpack_public_path__ + "static/media/65.3099907e.mp3";